<template>
  <div class="monthly-users-fluctuation-breakdown">
    <span class="sk-text-small-regular">
      {{ $t('quote_details_block.monthly_users_breakdown.description') }}
      <span class="text--grey">
        {{ additionalUserPrice }}
      </span>
    </span>
    <div class="monthly-users-fluctuation-breakdown__table">
      <div
        v-for="(month, index) in formattedMonths"
        :key="month.name + index"
        class="monthly-users-fluctuation-breakdown__table-column"
      >
        <span class="monthly-users-fluctuation-breakdown__table-header__cell text--grey">
          {{ getMonthName(month.name) }}
        </span>
        <span class="monthly-users-fluctuation-breakdown__table-row__cell">
          {{ month.value }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { MonthName } from '@skelloapp/svc-billing-automation-sdk';

export default {
  name: 'MonthlyUsersFluctuactionBreakdown',
  props: {
    seasonalityFluctuationMonths: {
      type: Object,
      required: true,
    },
    additionalUserPrice: {
      type: String,
      required: true,
    },
    locale: {
      type: String,
      required: true,
    },
  },
  computed: {
    formattedMonths() {
      return Object.values(MonthName)
        .map(month => ({
          name: month,
          value: this.seasonalityFluctuationMonths[month] || 0,
        }));
    },
  },
  methods: {
    getMonthName(monthKey) {
      return this.$t(`months.${monthKey.toLowerCase()}`);
    },
  },
};
</script>

<style lang="scss" scoped>

.monthly-users-fluctuation-breakdown {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
}

.monthly-users-fluctuation-breakdown__table {
    display: flex;
    align-self: stretch;
    align-items: flex-start;
    flex-direction: row;
    width: 100%;
    padding: 16px;
    border-radius: 4px;
    background: white;
    overflow-x: auto;
}

.monthly-users-fluctuation-breakdown__table-column {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex-grow: 1;
}

.monthly-users-fluctuation-breakdown__table-header__cell {
    display: flex;
    height: 36px;
    padding: 0 16px 8px 16px;
    align-items: center;
}

.monthly-users-fluctuation-breakdown__table-row__cell {
    display: flex;
    height: 44px;
    padding: 0 16px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    align-self: stretch;
    border-block: 1px solid $sk-grey-10;
}

.monthly-users-fluctuation-breakdown__table-column:first-child
  .monthly-users-fluctuation-breakdown__table-row__cell {
    border-left: 1px solid $sk-grey-10;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

.monthly-users-fluctuation-breakdown__table-column:last-child
  .monthly-users-fluctuation-breakdown__table-row__cell {
    border-right: 1px solid $sk-grey-10;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}

</style>
